/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Button, Input, message, Modal, Popover } from 'antd';
import InviteUsersModal from './inviteUsersModal';
import { useContext, useEffect, useState } from 'react';
import {
  CheckCircleOutlined,
  SearchOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import styles from 'styles/components/selectParticipantsModal.module.scss';
import { addUser, listSlackUsers, listUsers } from 'services/api/workspace';
import UserTable from './userTable';
import ProfileContext from 'services/profileContext';
import AddToSlackButton from './addToSlackButton';
import { useLocation } from 'react-router-dom';

const SelectParticipantsModal = ({
  participantsAlreadyInCycle = [],
  open,
  onCancel,
  onFinish,
  cycleId,
}) => {
  const [modalAddUserOpen, setModalAddUserOpen] = useState(false);
  const [usersInWorkspace, setUsersInWorkspace] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [addUserLoading, setAddUserLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [search, setSearch] = useState('');
  const location = useLocation();
  const { pathname } = location;
  const { profile } = useContext(ProfileContext);

  const listUsersInWorkspace = () => {
    const shouldListSlack = profile.workspace.slack;
    const promises = [listUsers()];
    if (shouldListSlack) {
      promises.push(listSlackUsers());
    }
    Promise.all(promises)
      .then(([res, resSlack]) => {
        setUsersInWorkspace([
          ...(res.data || []).map((e) => ({
            ...e,
            ...((resSlack?.data || []).find(
              (e2) => e2.slackUserId === e.slackUserId
            )
              ? { isSlackUserAlreadyInvited: true }
              : {}),
          })),
          ...(resSlack?.data || [])
            .filter(
              (e) => !res.data.find((e2) => e2.slackUserId === e.slackUserId)
            )
            .filter(
              (e) =>
                !res.data.find(
                  (e2) => e2.email.toLowerCase() === e.email.toLowerCase()
                )
            ),
        ]);
      })
      .catch((err) => {
        console.error('ERROR', err);
      });
  };
  const inviteUsersFinish = (values) => {
    setAddUserLoading(true);
    return addUser(values)
      .then((res) => {
        listUsersInWorkspace();
        setModalAddUserOpen(false);
        setSelectedUsers((selectu) => [...selectu, res.data._id]);
      })
      .catch((err) => {
        console.error('ERROR', err);
        if (err.response.data.error.code === 11000) {
          message.error(
            'User already exists in another workspace, try using an alias email.'
          );
        } else {
          message.error('Failed to Add users, please try again');
        }
      })
      .finally(() => {
        setAddUserLoading(false);
      });
  };

  useEffect(() => {
    listUsersInWorkspace();
  }, []);

  return (
    <>
      <Modal
        width={800}
        open={open}
        footer={null}
        onCancel={onCancel}
        title="Select participants for this cycle"
      >
        <div>
          <div className={styles.allMembersHeader}>
            <h2>{`All workspace members (${usersInWorkspace.length})`}</h2>{' '}
            <Button
              type="primary"
              onClick={() => setModalAddUserOpen(true)}
              icon={<UserAddOutlined />}
              style={{
                marginLeft: 12,
              }}
            >
              Add Users to the workspace
            </Button>
          </div>
          {!profile.workspace.slack && (
            <div>
              <Alert
                style={{ marginBottom: 12 }}
                type="warning"
                showIcon={true}
                message={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flexGrow: 1, fontWeight: 'bold' }}>
                      Connect your Slack Workspace to list team members
                    </div>
                    <AddToSlackButton
                      param={
                        pathname === '/create-cycle'
                          ? `createcycle${cycleId}`
                          : `selectParticipants${cycleId}`
                      }
                    />
                  </div>
                }
              />
            </div>
          )}
          <div>
            <Input
              placeholder="Search for a user"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              prefix={<SearchOutlined />}
              style={{ marginBottom: 12, width: '300px' }}
              allowClear
            />
          </div>
          <div>
            <UserTable
              users={usersInWorkspace}
              filterSearch={search}
              participantsAlreadyInCycle={participantsAlreadyInCycle}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              showSelection={true}
              showEditable={false}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Popover
              open={popoverOpen}
              trigger={['click']}
              overlayStyle={{ width: '500px' }}
              onOpenChange={(open) => {
                setPopoverOpen(open);
              }}
              content={
                <div>
                  Add users to the workspace to add them to the cycle.
                  <br />
                  <br />
                  <Button
                    style={{ marginRight: 22 }}
                    type="primary"
                    onClick={() => {
                      setPopoverOpen(false);
                      setModalAddUserOpen(true);
                    }}
                    icon={<UserAddOutlined />}
                  >
                    Add Users to the workspace
                  </Button>
                  <br />
                  <br />
                </div>
              }
              title=" Can't find the employee you're looking for?"
            >
              <Button type="link" onClick={() => setPopoverOpen(true)}>
                Can't find an employee?
              </Button>
            </Popover>
          </div>
          <div>
            <Button
              onClick={() => {
                const enrichedUsers = selectedUsers.map((u) => {
                  const user = usersInWorkspace.find((user) => user._id === u);
                  return {
                    userId: u,
                    ...(user || {}),
                  };
                });
                onFinish(enrichedUsers);
              }}
              type={'primary'}
              icon={<CheckCircleOutlined />}
            >
              Add Participants to the cycle
            </Button>
          </div>
        </div>
      </Modal>
      <InviteUsersModal
        open={modalAddUserOpen}
        onCancel={() => setModalAddUserOpen(false)}
        onFinish={inviteUsersFinish}
        loading={addUserLoading}
      />
    </>
  );
};

export default SelectParticipantsModal;
